var MobileSizes = Object.freeze({
    xxs: 4,
    xs: 8,
    s: 12,
    m: 16,
    l: 20,
    xl: 24,
    xxl: 32,
    xxxl: 48,
});
var TabletSizes = Object.freeze({
    xxs: 4,
    xs: 8,
    s: 16,
    m: 20,
    l: 24,
    xl: 32,
    xxl: 48,
    xxxl: 64,
});
var DesktopSizes = Object.freeze({
    xxs: 4,
    xs: 8,
    s: 16,
    m: 24,
    l: 32,
    xl: 48,
    xxl: 64,
    xxxl: 96,
});
export var Spacing = Object.freeze({
    mobile: MobileSizes,
    mobileLandscape: MobileSizes,
    tablet: TabletSizes,
    lap: DesktopSizes,
    desktop: DesktopSizes,
    wide: DesktopSizes,
});
export var FixedSpaceFragments = [
    0.25,
    0.5,
    0.75,
    1,
    1.25,
    1.5,
    2,
    2.5,
    3,
    3.5,
    4,
    5,
    6,
];
export function getFixedSpacing(fragment) {
    return 16 * fragment;
}
//# sourceMappingURL=Spacing.js.map